import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14f7ef5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "tit-box" }
const _hoisted_3 = { class: "img" }
const _hoisted_4 = { class: "rbox" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-tit" }, "费用申报", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-warn" }, "尹鹏处理中", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "descr" }, "尹鹏（得一集团网信部）", -1))
const _hoisted_8 = { class: "info block-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-tit" }, "申请详情", -1))
const _hoisted_10 = { class: "block-con" }
const _hoisted_11 = { class: "pics" }
const _hoisted_12 = { class: "pic-item" }
const _hoisted_13 = { class: "pic-item" }
const _hoisted_14 = { class: "jindu block-box" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-tit" }, "审批流程", -1))
const _hoisted_16 = { class: "block-con" }
const _hoisted_17 = { class: "jindu-item" }
const _hoisted_18 = { class: "pic" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rbox" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tit" }, [
    /*#__PURE__*/_createElementVNode("span", null, "发起审批"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", { class: "time" }, "2016-07-12 12:40")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "陈强")
], -1))
const _hoisted_20 = { class: "jindu-item" }
const _hoisted_21 = { class: "pic" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rbox" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tit" }, [
    /*#__PURE__*/_createElementVNode("span", null, "审批人"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", { class: "time" }, "2016-07-12 12:40")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "尹鹏（已同意）")
], -1))
const _hoisted_23 = { class: "jindu-item" }
const _hoisted_24 = { class: "pic" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rbox" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tit" }, [
    /*#__PURE__*/_createElementVNode("span", null, "审批人"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", { class: "time" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "刘总")
], -1))
const _hoisted_26 = { class: "acts" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("拒 绝")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("同 意")

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { getApproveInfo } from '@/apis/approval'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const approvalId = ref(0)
// 返回
const goBack = () => {
  router.back()
}

const get_Approve_Info = async () => {
  const res = await getApproveInfo({ id: approvalId.value })
  if (res.code === 200) console.log(res.data)
}

// 审批页
const goOperate = () => {
  router.push('/approval/operate')
}

onMounted(() => {
  approvalId.value = Number(router.currentRoute.value.query.id)
  get_Approve_Info()
})

return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_sticky = _resolveComponent("van-sticky")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "审批详情",
      "left-arrow": "",
      fixed: "",
      onClickLeft: goBack
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_image, {
          round: "",
          width: "50",
          height: "50",
          src: "https://img.yzcdn.cn/vant/cat.jpeg"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_cell, { border: false }, {
          title: _withCtx(() => [
            _hoisted_5
          ]),
          value: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_van_cell_group, {
          title: "项目名称",
          border: false,
          class: "mx-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "XX项目",
              size: "large"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "费用明细1",
          border: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "报销内容",
              value: "差旅费"
            }),
            _createVNode(_component_van_cell, {
              title: "报销事由",
              value: "从荆门到襄阳火车票"
            }),
            _createVNode(_component_van_cell, {
              title: "日期",
              value: "2022-02-21"
            }),
            _createVNode(_component_van_cell, {
              title: "金额（元）",
              value: "30.00"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "费用明细2",
          border: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "报销内容",
              value: "差旅费"
            }),
            _createVNode(_component_van_cell, {
              title: "报销事由",
              value: "从荆门到襄阳火车票"
            }),
            _createVNode(_component_van_cell, {
              title: "日期",
              value: "2022-02-21"
            }),
            _createVNode(_component_van_cell, {
              title: "金额（元）",
              value: "30.00"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "图片",
          border: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_van_image, {
                  width: "50",
                  height: "50",
                  src: "https://img.yzcdn.cn/vant/cat.jpeg"
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_van_image, {
                  width: "50",
                  height: "50",
                  src: "https://img.yzcdn.cn/vant/cat.jpeg"
                })
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_van_steps, {
          direction: "vertical",
          active: 1
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_van_image, {
                      round: "",
                      width: "50",
                      height: "50",
                      src: "https://img.yzcdn.cn/vant/cat.jpeg"
                    })
                  ]),
                  _hoisted_19
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_van_image, {
                      round: "",
                      width: "50",
                      height: "50",
                      src: "https://img.yzcdn.cn/vant/cat.jpeg"
                    })
                  ]),
                  _hoisted_22
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_van_image, {
                      round: "",
                      width: "50",
                      height: "50",
                      src: "https://img.yzcdn.cn/vant/cat.jpeg"
                    })
                  ]),
                  _hoisted_25
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_van_sticky, { position: "bottom" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_van_button, {
            plain: "",
            type: "danger"
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          }),
          _createVNode(_component_van_button, {
            plain: "",
            type: "primary",
            onClick: goOperate
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})